

export const BugSecurityIcon = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <path d="M0 0L23.605 0 23.605 23.605 0 23.605z" transform="translate(-688 -961) translate(406 961) translate(282)" />
                            <path  fill={props.isActive? '#3ac0a2':'#2e2744'} fillRule="nonzero" d="M5.956 8.163c.063-.1.128-.198.196-.295h11.3c.068.097.133.196.196.295l1.987-1.147.984 1.704-2.177 1.257c.16.58.245 1.193.245 1.825v.984h2.95v1.967h-2.95c.001.908-.178 1.807-.527 2.646l2.459 1.42-.984 1.703-2.484-1.434c-1.09 1.347-2.65 2.233-4.365 2.48v-7.799h-1.967v7.8c-1.716-.248-3.275-1.133-4.365-2.48l-2.485 1.433-.983-1.703 2.459-1.42c-.35-.838-.529-1.738-.527-2.646H1.967v-1.967h2.95v-.984c0-.632.086-1.244.246-1.825L2.986 8.72l.983-1.704 1.987 1.147zm1.912-2.262c0-2.173 1.762-3.934 3.934-3.934 2.173 0 3.934 1.761 3.934 3.934H7.868z" transform="translate(-688 -961) translate(406 961) translate(282)" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}